export const GET_HELP_CATEGORIES_START = 'GET_HELP_CATEGORIES_START';
export const GET_HELP_CATEGORIES_SUCCESS = 'GET_HELP_CATEGORIES_SUCCESS';
export const GET_HELP_CATEGORIES_FAILED = 'GET_HELP_CATEGORIES_FAILED';

export const GET_HELP_SUB_CATEGORIES_START = 'GET_HELP_SUB_CATEGORIES_START';
export const GET_HELP_SUB_CATEGORIES_SUCCESS = 'GET_HELP_SUB_CATEGORIES_SUCCESS';
export const GET_HELP_SUB_CATEGORIES_FAILED = 'GET_HELP_SUB_CATEGORIES_FAILED';

export const GET_HELP_TOPICS_START = 'GET_HELP_TOPICS_START';
export const GET_HELP_TOPICS_SUCCESS = 'GET_HELP_TOPICS_SUCCESS';
export const GET_HELP_TOPICS_FAILED = 'GET_HELP_TOPICS_FAILED';

export const GET_ALL_HELP_TOPICS_START = 'GET_ALL_HELP_TOPICS_START';
export const GET_ALL_HELP_TOPICS_SUCCESS = 'GET_ALL_HELP_TOPICS_SUCCESS';
export const GET_ALL_HELP_TOPICS_FAILED = 'GET_ALL_HELP_TOPICS_FAILED';

export const ADD_HELP_CATEGORY_START = 'ADD_HELP_CATEGORY_START';
export const ADD_HELP_CATEGORY_SUCCESS = 'ADD_HELP_CATEGORY_SUCCESS';
export const ADD_HELP_CATEGORY_FAILED = 'ADD_HELP_CATEGORY_FAILED';

export const ADD_HELP_SUB_CATEGORY_START = 'ADD_HELP_SUB_CATEGORY_START';
export const ADD_HELP_SUB_CATEGORY_SUCCESS = 'ADD_HELP_SUB_CATEGORY_SUCCESS';
export const ADD_HELP_SUB_CATEGORY_FAILED = 'ADD_HELP_SUB_CATEGORY_FAILED';

export const ADD_HELP_TOPIC_START = 'ADD_HELP_TOPIC_START';
export const ADD_HELP_TOPIC_SUCCESS = 'ADD_HELP_TOPIC_SUCCESS';
export const ADD_HELP_TOPIC_FAILED = 'ADD_HELP_TOPIC_FAILED';

export const EDIT_HELP_CATEGORY_START = 'EDIT_HELP_CATEGORY';
export const EDIT_HELP_CATEGORY_SUCCESS = 'EDIT_HELP_CATEGORY_SUCCESS ';
export const EDIT_HELP_CATEGORY_FAILED = 'EDIT_HELP_CATEGORY_FAILED';

export const EDIT_HELP_SUB_CATEGORY_START = 'EDIT_HELP_SUB_CATEGORY_START';
export const EDIT_HELP_SUB_CATEGORY_SUCCESS = 'EDIT_HELP_SUB_CATEGORY_SUCCESS ';
export const EDIT_HELP_SUB_CATEGORY_FAILED = 'EDIT_HELP_SUB_CATEGORY_FAILED';

export const EDIT_HELP_TOPIC_START = 'EDIT_HELP_TOPIC_START';
export const EDIT_HELP_TOPIC_SUCCESS = 'EDIT_HELP_TOPIC_SUCCESS';
export const EDIT_HELP_TOPIC_FAILED = 'EDIT_HELP_TOPIC_START_FAILED';

export const DELETE_HELP_CATEGORY_START = 'DELETE_HELP_CATEGORY_START';
export const DELETE_HELP_CATEGORY_SUCCESS = 'DELETE_HELP_CATEGORY_SUCCESS';
export const DELETE_HELP_CATEGORY_FAILED = 'DELETE_HELP_CATEGORY_FAILED';

export const DELETE_HELP_SUB_CATEGORY_START = 'DELETE_HELP_SUB_CATEGORY_START';
export const DELETE_HELP_SUB_CATEGORY_SUCCESS = 'DELETE_HELP_SUB_CATEGORY_SUCCESS';
export const DELETE_HELP_SUB_CATEGORY_FAILED = 'DELETE_HELP_SUB_CATEGORY_FAILED';

export const DELETE_HELP_TOPIC_START = 'DELETE_HELP_TOPIC_START';
export const DELETE_HELP_TOPIC_SUCCESS = 'DELETE_HELP_TOPIC_SUCCESS';
export const DELETE_HELP_TOPIC_FAILED = 'DELETE_HELP_TOPIC_FAILED';


export const getHelpCategoriesStart = () => ({
  type: GET_HELP_CATEGORIES_START
});

export const getHelpCategoriesSuccess = (data) => ({
  type: GET_HELP_CATEGORIES_SUCCESS,
  data
});

export const getHelpCategoriesFailed = (error) => ({
  type: GET_HELP_CATEGORIES_FAILED,
  error
});

export const getHelpSubCategoriesStart = () => ({
  type: GET_HELP_SUB_CATEGORIES_START
});

export const getHelpSubCategoriesSuccess = (data) => ({
  type: GET_HELP_SUB_CATEGORIES_SUCCESS,
  data
});

export const getHelpSubCategoriesFailed = (error) => ({
  type: GET_HELP_SUB_CATEGORIES_FAILED,
  error
});

export const getHelpTopicsStart = () => ({
  type: GET_HELP_TOPICS_START,
});

export const getHelpTopicsSuccess = (data) => ({
  type: GET_HELP_TOPICS_SUCCESS,
  data
});

export const getHelpTopicsFailed = (error) => ({
  type: GET_HELP_TOPICS_FAILED,
  error
});

export const getAllHelpTopicsStart = () => ({
  type: GET_ALL_HELP_TOPICS_START,
});

export const getAllHelpTopicsSuccess = (data) => ({
  type: GET_ALL_HELP_TOPICS_SUCCESS,
  data
});

export const getAllHelpTopicsFailed = (error) => ({
  type: GET_ALL_HELP_TOPICS_FAILED,
  error
});

export const addHelpCategoryStart = () => ({
  type: ADD_HELP_CATEGORY_START
});

export const addHelpCategorySuccess = (data) => ({
  type: ADD_HELP_CATEGORY_SUCCESS,
  data
});

export const addHelpCategoryFailed = (error) => ({
  type: ADD_HELP_CATEGORY_FAILED,
  error
});

export const addHelpSubCategoryStart = () => ({
  type: ADD_HELP_SUB_CATEGORY_START
});

export const addHelpSubCategorySuccess = (data) => ({
  type: ADD_HELP_SUB_CATEGORY_SUCCESS,
  data
});

export const addHelpSubCategoryFailed = (error) => ({
  type: ADD_HELP_SUB_CATEGORY_FAILED,
  error
});

export const addHelpTopicStart = () => ({
  type: ADD_HELP_TOPIC_START
});

export const addHelpTopicSuccess = (data) => ({
  type: ADD_HELP_TOPIC_SUCCESS,
  data
});

export const addHelpTopicFailed = (error) => ({
  type: ADD_HELP_TOPIC_FAILED,
  error
});

export const editHelpCategoryStart = () => ({
  type: EDIT_HELP_CATEGORY_START,
});

export const editHelpCategorySuccess = (data) => ({
  type: EDIT_HELP_CATEGORY_SUCCESS,
  data
});

export const editHelpCategoryFailed = (error) => ({
  type: EDIT_HELP_CATEGORY_FAILED,
  error
});

export const editHelpSubCategoryStart = () => ({
  type: EDIT_HELP_SUB_CATEGORY_START
});

export const editHelpSubCategorySuccess = (data) => ({
  type: EDIT_HELP_SUB_CATEGORY_SUCCESS,
  data
});

export const editHelpSubCategoryFailed = (error) => ({
  type: EDIT_HELP_SUB_CATEGORY_FAILED,
  error
});

export const editHelpTopicStart = () => ({
  type: EDIT_HELP_TOPIC_START
});

export const editHelpTopicSuccess = (data) => ({
  type: EDIT_HELP_TOPIC_SUCCESS,
  data
});

export const editHelpTopicFailed = (error) => ({
  type: EDIT_HELP_TOPIC_FAILED,
  error
});

export const deleteHelpCategoryStart = () => ({
  type: DELETE_HELP_CATEGORY_START
});

export const deleteHelpCategorySuccess = (data) => ({
  type: DELETE_HELP_CATEGORY_SUCCESS,
  data
});

export const deleteHelpCategoryFailed = (error) => ({
  type: DELETE_HELP_CATEGORY_FAILED,
  error
});

export const deleteHelpSubCategoryStart = () => ({
  type: DELETE_HELP_SUB_CATEGORY_START,
});

export const deleteHelpSubCategorySuccess = (data) => ({
  type: DELETE_HELP_SUB_CATEGORY_SUCCESS,
  data
});

export const deleteHelpSubCategoryFailed = (error) => ({
  type: DELETE_HELP_SUB_CATEGORY_FAILED,
  error
});

export const deleteHelpTopicStart = () => ({
  type: DELETE_HELP_TOPIC_START
});

export const deleteHelpTopicSuccess = (data) => ({
  type: DELETE_HELP_TOPIC_SUCCESS,
  data
});

export const deleteHelpTopicFailed = (error) => ({
  type: DELETE_HELP_TOPIC_FAILED,
  error
});
